import { Box } from '@chakra-ui/react';
import { useObtBreakpointValue } from 'src/hooks/useObtBreakpointValue';
import { LogoHeader } from './LogoHeader';
import { Outlet } from 'react-router-dom';

export const NoNavLayout = () => {
  const showDesktopView = useObtBreakpointValue({ base: false, sm: false, md: true, lg: true, xlTo2xl: true });
  return (
    <Box backgroundColor={'#F3F4F7'} minHeight={'100vh'}>
      <LogoHeader />
      <Box
        id='mainLayoutContainer'
        width={'100%'}
        height='100vh'
        overflowY='auto'
        paddingTop={showDesktopView ? '80px' : '55px'}>
        <Outlet />
      </Box>
    </Box>
  );
};
